<template>
  <div class="farm-list">

    <MobileSidebarWrapper :params="['farmId', 'fieldId']">
      <template slot="sidebar">
        <aside>
          <nav>
            <ul class="farms">
              <li
                class="farm"
                v-for="farm in farms"
                :key="farm.id"
                :ref="`farm-${farm.id}`"
                @click="$emit('selectFarm', farm.id), selectFarm(farm.id)"
                :class="{ is_active : (farm.id == selectFarmId) }"
              >
                <a draggable="false">
                  <span>{{farm.name}}</span>
                  <span class="info">{{farm.fields.length}} {{$ml.get(`fields`)}}</span>
                </a>
                <ul class="fields">
                  <li
                    class="field"
                    v-for="field in farm.fields"
                    :key="field.id"
                    @click="$emit('selectField', field.id), selectField(field.id)"
                    :class="{ is_active : field.id == selectFieldId }"
                  >
                    <a draggable="false">
                      <span>{{field.name}}</span>
                      <!-- <span class="info">{{field.area}} {{$ml.get(`hectares`)}}</span> -->
                      <span class="info">
                        {{$store.getters['unit/convert']('ha', field.area)}}
                        {{$store.getters['unit/getLabel']('ha')}}
                      </span>
                    </a>
                    <!-- <div class="view-details" v-if="field.id == selectFieldId">
                      <p>view details</p>
                    </div> -->
                  </li>
                </ul>

              </li>
              <app-btn
                v-show="this.selectFarmId != null"
                @click.capture="deleteFarm()"
                :danger="true">
                {{$ml.get(`Delete farm`)}}
              </app-btn>
            </ul>
          </nav>
        </aside>
      </template>
    </MobileSidebarWrapper>


    <div v-if="!farms.length || !fields.length">Please, define field first</div>

  </div>
</template>

<script>
import API from '@/api'
import MobileSidebarWrapper from '@/components/common/mobile-sidebar-wrapper/MobileSidebarWrapper'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      searchQuery : null,
      selectFieldId: null,
      selectFarmId: null,
    }
  },
  components: {
    MobileSidebarWrapper
  },
  computed : {
    ...mapGetters({
      fields: 'farms/fields',
      farms: 'farms/farms',
    })
  },
  methods : {
    expandFields(e,i) {
      let farms = document.querySelectorAll('ul.farms li.farm');
      farms.forEach( (el) =>  {
        el.classList.remove('is_active');
      } );
      this.$refs[`farm-${i}`][0].classList.add('is_active')
    },
    selectField(id) {
      this.selectFieldId = id;
    },
    selectFarm(id){
      this.selectFarmId = id;
    },
    //=================================================================================
    deleteFarm(){
      return API.fields.deleteFarm(this.selectFarmId).then(res => {
        this.$router.push('/dashboard/farms/map-view');
        this.$store.dispatch('farms/updateData');
         try {
              let result = JSON.parse(JSON.stringify(res));
              console.log(result.data.message);
              if (result.data.message == 'Please buy a plan!') {
                this.$notify({
                  group: "notices",
                  title: this.$ml.get(
                    `Please buy a plan before deleting farms.`
                  ),
                  type: "error",
                });
              }
            } catch (e) {}
      });
    }
    //=================================================================================
  },
  beforeCreate() {
    this.$store.dispatch('farms/updateData').then(res => {
      // this.allUserFarms = this.$store.getters['farms/data'];
      // this.farms = this.$store.getters['farms/data'];
      this.fields = this.$store.getters['farms/fields'];
    });

  },

}
</script>

<style lang="scss" scoped>
.farm-list {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  height: 100%;
  aside {
    min-width: 320px;
    nav {
      ul.farms {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        li.farm {
          list-style-type: none;
          border-bottom: 1px solid #E0E0E0;
          display: flex;
          flex-direction: column;
          padding-bottom: 4px;
          margin-bottom: 4px;
          &.is_active {
            > a {
              background-color: $mainGreen;
              color: #fff;
              // border-bottom-right-radius: 0;
              // border-bottom-left-radius: 0;
            }
            ul.fields {
              height: auto;
              max-height: 350px;
              overflow-y: auto;
            }
          }
          &:first-child {
            border-top: 1px solid #E0E0E0;
          }
          a {
            width: 100%;
            cursor: pointer;
            padding: 16px;
            color: #4C5056;
            font-size: 16px;
            font-weight: 500;
            border-radius: 5px;
            overflow: hidden;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            transition: .3s;
            span {
              pointer-events: none;
              &.info {
                font-size: 12px;
                text-transform: uppercase;
                white-space: nowrap;
                padding-left: 4px;
              }
            }
          }
          ul.fields {
            background-color: #F3F3F3;
            padding: 0;
            margin: 0 4px;
            display: flex;
            flex-direction: column;
            height:0;
            overflow: hidden;
            transition: .3s;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            li.field {
              border-bottom: 1px solid #E0E0E0;
              list-style-type: none;
              display: flex;
              flex-direction: column;
              margin-top: 2px;
              padding-top: 2px;
              cursor: pointer;
              &:last-child {
                border-bottom-width: 0;
              }
              &.is_active {
                a {
                  color: #fff;
                  background-color: $mainGreen;
                }
              }
              .view-details {
                text-align: center;
                font-size: 14px;
                text-decoration: underline;
                p {
                  margin: 0;
                }
              }
            }
          }
        }
      }
    }
  }

}
</style>
